/**
 * The web chrome's English strings (B9). Keys are `<area>.<thing>`; every entry here has an
 * Arabic twin in `strings.ar.ts`, and the two files are keyed identically — a missing or extra
 * key fails `tsc`.
 */
export const en = {
  'account.backToChats': 'Back to chats',
  'account.cancel': 'Cancel',
  'account.changePassword': 'Change password',
  'account.changePhoto': 'Change profile photo',
  'account.changingPassword': 'Changing the password',
  'account.confirmPassword': 'Confirm new password',
  'account.currentPassword': 'Current password',
  'account.displayName': 'Display name',
  'account.errorChangePassword': 'Could not change the password.',
  'account.errorCurrentPassword': 'That current password is not right.',
  'account.errorLoadSessions': 'Could not load your sessions.',
  'account.errorNameLength': 'A display name is 1–64 characters.',
  'account.errorNewPasswordShort': 'A new password is at least 8 characters.',
  'account.errorPasswordMismatch': 'The two new passwords do not match.',
  'account.errorPrivacy': 'Could not update your privacy settings.',
  'account.errorRevoke': 'Could not revoke that session.',
  'account.errorSaveName': 'Could not save your name.',
  'account.errorUploadPhoto': 'Could not upload the photo.',
  'account.language': 'Language',
  'account.languageHint': 'The interface follows this choice; System follows this device. Messages keep their own direction either way.',
  'account.languageSystem': 'System',
  'account.lastSeen': 'Last seen',
  'account.lastSeenHint': 'While it is off, nobody sees when you were last online — not in a chat, not in the directory. You still see everyone else’s.',
  'account.loading': 'Loading…',
  'account.loadingSessions': 'Loading your sessions',
  'account.me': 'Me',
  'account.nameSaved': 'Name saved.',
  'account.neverSeen': 'never seen',
  'account.newPassword': 'New password',
  'account.noDevices': 'No devices signed in.',
  'account.password': 'Password',
  'account.passwordChanged': 'Password changed.',
  'account.passwordHint': 'At least 8 characters. Changing it keeps you signed in here.',
  'account.privacy': 'Privacy',
  'account.privacySaved': 'Privacy settings saved.',
  'account.profile': 'Profile',
  'account.readReceipts': 'Read receipts',
  'account.readReceiptsHint': 'While it is off, nobody is told that you read their message — not even the person who wrote it. You still see the read state of everyone who keeps it on.',
  'account.revoke': 'Revoke',
  'account.revokeDevice': 'Revoke {name}',
  'account.revokeDeviceConfirm': '{name} will be signed out on its next request.',
  'account.revokeThisDeviceConfirm': '{name} is this device. Revoking it signs you out here, and you will need an invite or recovery code to sign back in.',
  'account.revoking': 'Revoking',
  'account.save': 'Save',
  'account.saving': 'Saving',
  'account.sessions': 'Sessions',
  'account.sessionsHint': 'Revoking a session signs it out on its next request. The one marked “This device” is this browser — revoking it signs you out here.',
  'account.tapPhoto': 'Tap the photo to change it.',
  'account.thisDevice': 'This device',
  'account.title': 'Account',
  'account.unknownPlatform': 'unknown platform',
  'account.unnamedDevice': 'Unnamed device',
  'adminRedirect.body': 'Approvals, members, invites and recovery links live on their own site now. Taking you to',
  'adminRedirect.title': 'Admin moved to the console',
  'approval.notApproved': 'Not approved',
  'approval.pendingBody': 'Your account was created, and an admin has to let it in before you can use olmt·call. This page checks by itself — leave it open and the app will open on its own.',
  'approval.rejectedBody': 'An admin turned this account down.',
  'approval.signedInAs': 'Signed in as',
  'approval.suspendedBody': 'This account has been suspended by an admin.',
  'approval.unreachable': 'Cannot reach the server — still trying.',
  'approval.useDifferentAccount': 'Use a different account',
  'approval.waiting': 'Waiting for approval',
  'auth.backToSignIn': 'Back to sign in',
  'auth.createAccount': 'Create account',
  'auth.creatingAccount': 'Creating your account',
  'auth.deviceName': 'Device name',
  'auth.deviceNameHint': 'Only so you can recognise this phone in your list of devices. It is not shown to anyone else.',
  'auth.displayName': 'Display name',
  'auth.email': 'Email',
  'auth.errorBadCredentials': 'Wrong email or password.',
  'auth.errorCredentials': 'Enter your email and password.',
  'auth.errorDisplayName': 'Enter a display name.',
  'auth.errorEmail': 'Enter your email address.',
  'auth.errorEmailTaken': 'That email already has an account. Sign in instead.',
  'auth.errorGeneric': 'Something went wrong. Try again.',
  'auth.errorInviteCode': 'Enter your invite or recovery code.',
  'auth.errorInviteDisplayName': 'Enter a display name to join as a new account.',
  'auth.errorInviteInvalid': 'This invite link is not valid any more.',
  'auth.errorNetwork': 'Cannot reach the server. Check your connection.',
  'auth.errorPasswordShort': 'Your password needs at least 8 characters.',
  'auth.errorRateLimited': 'Too many attempts — wait a moment and try again.',
  'auth.errorTooLarge': 'That request was too large.',
  'auth.haveInvite': 'Have an invite?',
  'auth.inviteCode': 'Invite or recovery code',
  'auth.inviteCodeHint': 'Joining for the first time? Enter a display name too. Adding this device to an account you already have? Leave it blank.',
  'auth.join': 'Join',
  'auth.joinNotice': 'An invite code creates your account; a recovery code adds this device to one you already have. Both look the same — paste whichever you were given.',
  'auth.joinTitle': 'Join with an invite',
  'auth.joining': 'Joining',
  'auth.modeGroup': 'Create an account or sign in',
  'auth.password': 'Password',
  'auth.passwordHint': 'At least 8 characters.',
  'auth.signIn': 'Sign in',
  'auth.signingIn': 'Signing in',
  'auth.signupNotice': 'New accounts wait for an admin’s approval before the app opens — you will see a waiting screen until then, and it enters on its own once you are approved.',
  'auth.tagline': 'Your family’s own line. Calls, voice notes and messages stay on this server.',
  'call.answer': 'Answer',
  'call.answerCall': 'Answer call',
  'call.answeredElsewhere': 'Answered on another device',
  'call.answeredElsewhereDetail': 'The call is running on the device you answered it on.',
  'call.audio': 'Call audio',
  'call.backToChats': 'Back to chats',
  'call.bluetooth': 'Bluetooth',
  'call.camera': 'Camera',
  'call.cameraN': 'Camera {number}',
  'call.cameraOff': 'Camera off',
  'call.cameraTurnOff': 'Turn camera off',
  'call.cameraTurnOn': 'Turn camera on',
  'call.cancelCall': 'Cancel call',
  'call.connected': 'Connected',
  'call.connecting': 'Connecting…',
  'call.couldNotJoin': 'Could not join the call.',
  'call.decline': 'Decline',
  'call.declineCall': 'Decline call',
  'call.declinedElsewhere': 'Declined on another device',
  'call.declinedElsewhereDetail': 'This device has stopped ringing.',
  'call.deviceDefault': 'Default',
  'call.deviceSwitchFailed': 'Could not switch the audio output.',
  'call.deviceUnavailable': 'Camera or microphone is unavailable.',
  'call.disconnected': 'Disconnected',
  'call.dismiss': 'Dismiss',
  'call.earpiece': 'Earpiece',
  'call.endCall': 'End call',
  'call.ended': 'Call ended',
  'call.everyoneHungUp': 'Everyone has hung up.',
  'call.headphones': 'Headphones',
  'call.hostDisconnected': 'disconnected',
  'call.hostDisconnectedReason': 'disconnected: {reason}',
  'call.hostJoinFailed': 'join failed — {detail}',
  'call.hostMissingCallId': 'missing call id',
  'call.hostNoSession': 'no session — this WebView has never signed in',
  'call.incomingVideoCall': 'Incoming video call',
  'call.incomingVideoCallFrom': 'Incoming video call from {name}',
  'call.incomingVoiceCall': 'Incoming voice call',
  'call.incomingVoiceCallFrom': 'Incoming voice call from {name}',
  'call.invitePeople': 'Invite people',
  'call.join': 'Join',
  'call.joining': 'Joining',
  'call.joiningCall': 'Joining the call',
  'call.joiningCallEllipsis': 'Joining the call…',
  'call.levelPrompt': 'Say something — this is how loud you are',
  'call.loadingCall': 'Loading call',
  'call.micOff': 'Your microphone is off',
  'call.micTurnOff': 'Turn microphone off',
  'call.micTurnOn': 'Turn microphone on',
  'call.microphone': 'Microphone',
  'call.microphoneN': 'Microphone {number}',
  'call.muteMic': 'Mute microphone',
  'call.noLongerRinging': 'This call is no longer ringing on this server.',
  'call.output': 'Audio output',
  'call.outputN': 'Audio output {number}',
  'call.peopleCount': '{count} people',
  'call.personCount': '{count} person',
  'call.prejoinCameraMicHint': 'Check your camera and microphone',
  'call.prejoinMicHint': 'Check your microphone',
  'call.reconnecting': 'Reconnecting…',
  'call.ringingMany': 'Ringing {count} people…',
  'call.ringingOne': 'Ringing {name}…',
  'call.screen': 'screen',
  'call.shareScreen': 'Share screen',
  'call.someone': 'Someone',
  'call.speaker': 'Speaker',
  'call.stopScreenShare': 'Stop sharing screen',
  'call.tapToHearAudio': 'Tap to hear audio',
  'call.unavailable': 'Call unavailable',
  'call.unknownError': 'unknown error',
  'call.unmuteMic': 'Unmute microphone',
  'call.videoCall': 'Video call',
  'call.voiceCall': 'Voice call',
  'call.volume': 'Volume',
  'call.volumeFor': 'Volume for {name}',
  'call.waitingForOthers': 'Waiting for others',
  'call.waitingForVideo': 'Waiting for video',
  'call.you': 'you',
  'calls.backToChats': 'Back to chats',
  'calls.callBack': 'Call back',
  'calls.duration': 'Call lasted {duration}',
  'calls.empty': 'No calls yet.',
  'calls.failed': 'Could not start the call.',
  'calls.incoming': 'Incoming call',
  'calls.loadFailed': 'Could not load your calls.',
  'calls.loading': 'Loading calls',
  'calls.missed': 'Missed call',
  'calls.open': 'Call history',
  'calls.outgoing': 'Outgoing call',
  'calls.title': 'Calls',
  'chat.add': 'Add',
  'chat.addPeople': 'Add people',
  'chat.addPeopleCount': 'Add {count} people',
  'chat.addToHomeScreen': 'Add to Home Screen',
  'chat.adding': 'Adding…',
  'chat.adminConsole': 'Admin console',
  'chat.back': 'Back',
  'chat.backToChats': 'Back to chats',
  'chat.callInProgressOne': 'Call in progress · {count} member',
  'chat.callInProgressOther': 'Call in progress · {count} members',
  'chat.callsInBackground': 'Calls in the background',
  'chat.cancel': 'Cancel',
  'chat.cancelEdit': 'Cancel edit',
  'chat.cancelSelect': 'Cancel selection',
  'chat.changePhoto': 'Change photo',
  'chat.chatDetails': 'Chat details',
  'chat.chatPinned': 'Pinned to the top',
  'chat.chatUnpinned': 'Not pinned',
  'chat.chats': 'Chats',
  'chat.chooseWhoToAdd': 'Choose who to add to this chat.',
  'chat.chooseWhoToRing': 'Choose who to ring into this call.',
  'chat.close': 'Close',
  'chat.closePhoto': 'Close photo',
  'chat.connecting': 'Connecting…',
  'chat.contactInfo': 'Contact info',
  'chat.copied': 'Copied.',
  'chat.copy': 'Copy',
  'chat.copyFailed': 'Could not copy the message.',
  'chat.couldNotAddMembers': 'Could not add them to the chat.',
  'chat.couldNotChangePhoto': 'Could not change the photo.',
  'chat.couldNotCreateChat': 'Could not create the chat.',
  'chat.couldNotLeave': 'Could not leave the chat.',
  'chat.couldNotLoadChat': 'Could not load this chat.',
  'chat.couldNotLoadMembers': 'Could not load members.',
  'chat.couldNotRemoveMember': 'Could not remove them from the chat.',
  'chat.couldNotRename': 'Could not rename the chat.',
  'chat.couldNotRing': 'Could not ring them into the call.',
  'chat.couldNotStartCall': 'Could not start the call.',
  'chat.couldNotUpdateMute': 'Could not update notification settings.',
  'chat.couldNotUpdatePin': 'Could not update the pin.',
  'chat.createGroup': 'Create group',
  'chat.creating': 'Creating…',
  'chat.delete': 'Delete',
  'chat.deleteConfirmBody': 'It is deleted for everyone in the chat.',
  'chat.deleteConfirmTitle': 'Delete message?',
  'chat.deleteFailed': 'Could not delete the message.',
  'chat.deleteSelected': '{count} messages will be deleted for everyone in the chat.',
  'chat.deleting': 'Deleting',
  'chat.disappearing24Hours': '24 hours',
  'chat.disappearing7Days': '7 days',
  'chat.disappearing90Days': '90 days',
  'chat.disappearingBanner': 'Messages in this chat disappear after {window}.',
  'chat.disappearingFailed': 'Could not change the disappearing timer.',
  'chat.disappearingHint': 'Messages older than the timer are deleted for everyone in this chat. Off is the default.',
  'chat.disappearingMessages': 'Disappearing messages',
  'chat.disappearingOff': 'Off',
  'chat.disappearingUpdating': 'Updating the timer',
  'chat.downloadFile': 'Download {name}',
  'chat.edit': 'Edit',
  'chat.editFailed': 'Could not save the edit.',
  'chat.edited': 'edited',
  'chat.editing': 'Editing message',
  'chat.enableNotifications': 'Enable notifications',
  'chat.everyoneAlreadyIn': 'Everyone is already in this chat.',
  'chat.export': 'Export chat',
  'chat.exportBuilding': 'Building your copy',
  'chat.exportFailed': 'Could not export the chat.',
  'chat.exportHint': 'A ZIP with the messages and their media, built for you and kept for a week. Exporting deletes nothing — it is a copy.',
  'chat.exportMediaOne': '{count} media file',
  'chat.exportMediaOther': '{count} media files',
  'chat.exportMessagesOne': '{count} message',
  'chat.exportMessagesOther': '{count} messages',
  'chat.exportReady': 'Exported {messages} and {media} ({size}).',
  'chat.exportTitle': 'Your own copy of this chat',
  'chat.fallbackTitle': 'Chat',
  'chat.forward': 'Forward',
  'chat.forwardFailed': 'Could not forward the message.',
  'chat.forwardPick': 'Pick the chats to forward to.',
  'chat.forwardSend': 'Send',
  'chat.forwardTitle': 'Forward to',
  'chat.forwarded': 'Forwarded',
  'chat.forwardedTo': 'Forwarded to {count} chats',
  'chat.forwardedToOne': 'Forwarded to one chat',
  'chat.forwarding': 'Forwarding…',
  'chat.groupDetails': 'Group details',
  'chat.groupName': 'Group name',
  'chat.groupNameOptional': 'Group name (optional)',
  'chat.groupNamePlaceholder': 'Family',
  'chat.groupSubtitle': '{members} · {online} online',
  'chat.inCall': 'In call',
  'chat.inviteToCall': 'Invite to call',
  'chat.leave': 'Leave',
  'chat.leaveChat': 'Leave chat',
  'chat.leaveConfirm': 'Leave {name}? You will stop receiving its messages.',
  'chat.leaving': 'Leaving',
  'chat.liveCount': 'live · {count}',
  'chat.loadOlderMessages': 'Load older messages',
  'chat.loading': 'Loading…',
  'chat.loadingChatDetails': 'Loading chat details',
  'chat.loadingMembers': 'Loading members',
  'chat.loadingMessages': 'Loading messages',
  'chat.loadingOlderMessages': 'Loading older messages',
  'chat.loadingPhoto': 'Loading photo',
  'chat.loadingVideo': 'Loading video',
  'chat.me': 'Me',
  'chat.memberCountOne': '{count} member',
  'chat.memberCountOther': '{count} members',
  'chat.memberFallback': 'Member',
  'chat.membersHeading': 'Members · {count}',
  'chat.mentionInsert': 'Mention {handle}',
  'chat.mentionedYou': 'Mentioned you',
  'chat.mentionsEmpty': 'No member has that handle.',
  'chat.mentionsTitle': 'Mention a member',
  'chat.menu': 'Menu',
  'chat.messageActions': 'Message actions',
  'chat.messageDeleted': 'Message deleted',
  'chat.mute1Week': '1 week',
  'chat.mute8Hours': '8 hours',
  'chat.muteForever': 'Forever',
  'chat.muted': 'Muted',
  'chat.mutedForever': 'Muted forever',
  'chat.mutedUntil': 'Muted until {date}',
  'chat.newChat': 'New chat',
  'chat.noChats': 'No chats yet',
  'chat.noChatsHint': 'Start one with the people you want in it. Everyone in a chat sees it on their phone.',
  'chat.noMessages': 'No messages yet',
  'chat.noOneToInvite': 'No one else in this chat to invite.',
  'chat.noOtherMembers': 'No other members yet.',
  'chat.notificationStateBlocked': 'Blocked in settings',
  'chat.notificationStateOff': 'Off — turn on',
  'chat.notificationStateOn': 'On',
  'chat.notifications': 'Notifications',
  'chat.notificationsBlockedInSettings': 'Notifications blocked in settings',
  'chat.notificationsEnabled': 'Notifications enabled',
  'chat.notificationsOn': 'Notifications on',
  'chat.offline': 'offline',
  'chat.offlineNotice': 'Offline — messages will not arrive live.',
  'chat.openAChat': 'Open a chat',
  'chat.openAChatHint': 'Pick a name on the left to read it, or start a call from inside the chat.',
  'chat.openChat': 'Open chat',
  'chat.openPhoto': 'Open photo',
  'chat.pauseVoiceMessage': 'Pause voice message',
  'chat.photo': 'Photo',
  'chat.photoUnavailable': 'Photo unavailable',
  'chat.photoUploading': 'Uploading…',
  'chat.pickMembersHint': 'Pick one member for a direct chat, or several for a group.',
  'chat.pin': 'Pin',
  'chat.pinFailed': 'Could not pin the message.',
  'chat.pinned': 'Pinned',
  'chat.pinnedMessage': 'Pinned message',
  'chat.playVideo': 'Play video',
  'chat.playVoiceMessage': 'Play voice message',
  'chat.previewCall': 'Call',
  'chat.previewFile': 'File',
  'chat.previewVideo': 'Video',
  'chat.previewVoice': 'Voice message',
  'chat.react': 'React',
  'chat.reactFailed': 'Could not react to the message.',
  'chat.reactWith': 'React with {emoji}',
  'chat.read': 'Read',
  'chat.remove': 'Remove',
  'chat.removeFromSelection': 'Remove from selection',
  'chat.removeMember': 'Remove {name}',
  'chat.removeMemberConfirm': 'Remove {name} from this chat?',
  'chat.removeReaction': 'Remove {emoji}',
  'chat.removing': 'Removing',
  'chat.rename': 'Rename',
  'chat.reply': 'Reply',
  'chat.replyTo': 'Reply to {target}',
  'chat.ring': 'Ring',
  'chat.ringCount': 'Ring {count} people',
  'chat.ringing': 'Ringing…',
  'chat.save': 'Save',
  'chat.saveEdit': 'Save edit',
  'chat.select': 'Select',
  'chat.selected': '{count} selected',
  'chat.selectedCount': '{count} selected',
  'chat.selectedMembers': 'Selected members',
  'chat.sending': 'Sending',
  'chat.sent': 'Sent',
  'chat.signOut': 'Sign out',
  'chat.someone': 'Someone',
  'chat.systemMessage': 'System message',
  'chat.typingIndicator': 'typing…',
  'chat.typingMany': '{names} are typing',
  'chat.typingOne': '{names} is typing',
  'chat.unknownAuthor': 'Unknown',
  'chat.unmute': 'Unmute',
  'chat.unmuted': 'Unmuted',
  'chat.unpin': 'Unpin',
  'chat.unpinFailed': 'Could not unpin the message.',
  'chat.unreadMessages': 'Unread messages',
  'chat.unreadMessagesSuffix': 'unread messages',
  'chat.updatingMute': 'Updating mute setting',
  'chat.updatingPin': 'Updating pin',
  'chat.videoCall': 'Video call',
  'chat.voiceCall': 'Voice call',
  'chat.you': 'You',
  'chat.youBadge': 'you',
  'chat.yourMessage': 'your message',
  'composer.attach': 'Attach',
  'composer.attachFile': 'File',
  'composer.attachPhoto': 'Photo',
  'composer.attachVideo': 'Video',
  'composer.cancelRecording': 'Cancel recording',
  'composer.cancelReply': 'Cancel reply',
  'composer.closeAttachments': 'Close attachments',
  'composer.messageNotSent': 'Message not sent — check your connection.',
  'composer.micBlocked': 'Microphone access is blocked.',
  'composer.placeholder': 'Message',
  'composer.record': 'Record voice message',
  'composer.recording': 'Recording…',
  'composer.reply': 'Reply',
  'composer.send': 'Send message',
  'composer.sendVoiceMessage': 'Send voice message',
  'composer.storageFull': 'The server is low on disk space — uploads are paused until the admin frees room.',
  'composer.tooLarge': '{name} is too large to send.',
  'composer.uploadFailed': 'Could not upload {name}.',
  'composer.uploading': 'Uploading',
  'composer.voiceMessage': 'Voice message',
  'notFound.backToChats': 'Back to chats',
  'notFound.body': 'That link does not lead anywhere on this server.',
  'notFound.title': 'Page not found',
  'poll.addOption': 'Add option',
  'poll.errorOptionCount': 'A poll has between 2 and 10 options.',
  'poll.errorOptionEmpty': 'An option cannot be empty.',
  'poll.errorOptionLong': 'An option is at most 80 characters.',
  'poll.errorQuestion': 'A poll needs a question.',
  'poll.failed': 'Could not save your vote.',
  'poll.multiple': 'Allow multiple choices',
  'poll.multipleHint': 'Members can choose more than one option.',
  'poll.option': 'Option {number}',
  'poll.question': 'Question',
  'poll.removeOption': 'Remove option {number}',
  'poll.send': 'Send poll',
  'poll.title': 'New poll',
  'poll.unvote': 'Take back your vote for {option}',
  'poll.vote': 'Vote for {option}',
  'poll.votes': '{count} votes',
  'poll.votesOne': 'One vote',
  'presence.lastSeenDate': 'last seen {date}',
  'presence.lastSeenHours': 'last seen {count} h ago',
  'presence.lastSeenJustNow': 'last seen just now',
  'presence.lastSeenMinutes': 'last seen {count} min ago',
  'presence.offline': 'offline',
  'presence.online': 'online',
  'pwa.dismiss': 'Dismiss',
  'pwa.newVersion': 'A new version is available.',
  'pwa.offlineReady': 'Ready to work offline.',
  'pwa.reload': 'Reload',
  'ring.allowBackground': 'Allow background',
  'ring.allowBackgroundHint': 'One tap, one system dialog — no second app, and nothing is installed.',
  'ring.androidOnlyBody': 'This screen configures the Android app — the battery exemption, the reconnect speed and the HiOS settings that decide whether a call can ring with the app closed. In a browser there is nothing to configure: pushes are delivered by the browser’s own push service, which the phone already manages for you.',
  'ring.androidOnlyTitle': 'Android only',
  'ring.backToChats': 'Back to chats',
  'ring.batterySettings': 'Battery settings',
  'ring.batteryTitle': 'Battery optimization',
  'ring.checkingLink': 'Checking the background link',
  'ring.connectionBody': 'While the app is open, the app itself holds the connection. Android then keeps a single background connection for when it is not — one socket per device, never two.',
  'ring.connectionTitle': 'Connection',
  'ring.exempt': 'Exempt. Doze and App Standby will not cut the connection.',
  'ring.fragileSuffix': '(shortened until the link is protected again)',
  'ring.notExempt': 'Not exempt. Android will suspend the connection with the screen off, so calls can be missed.',
  'ring.nowLabel': 'Now:',
  'ring.offWithLink': '(off with the link)',
  'ring.openAppSettings': 'Open this app’s settings',
  'ring.presetBalancedDetail': 'Reconnects within about five minutes · 288 wake-ups a day.',
  'ring.presetBalancedLabel': 'Balanced — 5 min',
  'ring.presetFastDetail': 'Reconnects within about a minute of a swipe-kill · 1 440 wake-ups a day.',
  'ring.presetFastLabel': 'Fastest — 1 min',
  'ring.presetSaverDetail': 'Reconnects within about fifteen minutes · 96 a day.',
  'ring.presetSaverLabel': 'Battery saver — 15 min',
  'ring.presetSuffix': '({preset} preset)',
  'ring.reconnectBody': 'A watchdog alarm repairs the link after Android or HiOS kills the app. Recovery after a swipe-kill takes up to the chosen interval. While the link is up but not yet protected — no silent keep-alive, e.g. right after a reboot — the app shortens the alarm to one minute on its own, whatever is chosen here.',
  'ring.reconnectTitle': 'Reconnect speed',
  'ring.statusChecking': 'Checking…',
  'ring.statusConnected': 'Connected — calls ring while the app is in the background.',
  'ring.statusOff': 'Off — calls only ring while the app is open.',
  'ring.statusStandby': 'Standing by — the app holds the connection while it is open.',
  'ring.statusUnsupported': 'This build has no background-link support.',
  'ring.statusWaiting': 'Waiting for the app to start it.',
  'ring.stepAutoStart': 'Auto-start management',
  'ring.stepAutoStartDetail': 'Phone Master → Toolbox → Auto-start management → allow olmt-call to run in the background.',
  'ring.stepBatterySaver': 'Battery saver and Power Boost, off',
  'ring.stepBatterySaverDetail': 'Phone Master → Power Marathon → Power Boost OFF. Do not run Phone Master’s "clean/boost" on this app.',
  'ring.stepLockApp': 'Lock the app in Recents',
  'ring.stepLockAppDetail': 'Open Recents, tap the 🔒 on the olmt-call card so the cleaner cannot dismiss it.',
  'ring.stepPowerSaving': 'Power Saving Management, off',
  'ring.stepPowerSavingDetail': 'Settings → Battery Lab → Battery Saving Settings → disable Power Saving Management For Apps.',
  'ring.stepPushBlock': 'Screen-off push block, off',
  'ring.stepPushBlockDetail': 'Advanced settings → Screen off push block, Screen off sleep and Screen off scheduled push all OFF.',
  'ring.tecnoBody': 'HiOS freezes foreground services and sockets on its own schedule, and Transsion exposes no API to detect or fix it. These are settings, not installs — the app cannot change them for you.',
  'ring.tecnoTitle': 'TECNO / HiOS settings',
  'ring.title': 'Calls in the background',
  'ring.turnOff': 'Turn off',
  'ring.turnOn': 'Turn on',
  'search.clear': 'Clear search',
  'search.close': 'Close search',
  'search.empty': 'No messages match “{query}”.',
  'search.failed': 'Could not search. Try again.',
  'search.inThisChat': 'Search in this chat',
  'search.label': 'Search messages',
  'search.loading': 'Searching',
  'search.media': 'Media',
  'search.messages': 'Messages',
  'search.more': 'More',
  'search.olderThanLoaded': 'That message is older than what is loaded here.',
  'search.placeholder': 'Search messages',
  'search.resultsOne': '{count} result for “{query}”',
  'search.resultsOther': '{count} results for “{query}”',
  'search.resultsPartial': '{count} or more results for “{query}”',
  'spinner.loading': 'Loading',
  'time.today': 'Today',
  'time.yesterday': 'Yesterday',
  'voice.seek': 'Voice message position',
  'voice.speed': '{speed}',
  'voice.speedAction': 'Playback speed {speed} — press to change',
} as const
